import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://nqihavydaiokkvcjnypl.supabase.co";
const supabaseAnonKey = "sb_publishable_LPWxY3SHeDUnOD78kM3zaA_Cairrwe3";

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey
)